/**
 * This file is a component for E2 UI Customization
 */
 import React, {useState, useEffect} from 'react';
 import { Grid, Tooltip, FormControlLabel, Checkbox} from '@material-ui/core';
 import ReplyOutlinedIcon from '@material-ui/icons/ReplyOutlined';

 export default function EmailReply(props)
 {
     const [reply, setReply] = useState(false);
 
     /** Set reply to value being passed through props */
     useEffect(() => {
         setReply(props.value);
     },[props.value]);
     
     /**Handle changes to live chat checkbox */
     const handleReply = () => {
         setReply(!reply);
         props.onChange(!reply);
     }
 
     return(
         <div>
             <Grid container direction="row" alignItems="center">
                 <Grid item>
                     <FormControlLabel
                     control={
                         <Checkbox
                         checked={reply}
                         onChange={handleReply}
                         name="reply"
                         color="primary"
                         />
                     }
                     label="Reply"
                     />
                 </Grid>
                 <Grid item>
                     <Tooltip title="Toggles the button that allows the agent to reply to the email message.">
                         <ReplyOutlinedIcon color="primary"/>
                     </Tooltip>
                 </Grid>
             </Grid>
         </div>
     );
 }
 
 